import {Carousel} from "react-bootstrap";
import {Link, NavLink} from "react-router-dom";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";

export const slider = (context) => {
    return (

        <div className='row cBefore1 pt-3 position-relative cPx1 justify-content-center'>
             <div className='cContainer col-12'>
                 <div className='row'>
            <div className='col-12 d-none d-md-block cDescktop'>
                <Carousel fade indicators={false} pause={false} interval={5000}>
                    {context.state.sHome.slider.map((p, index) => (
                        <Carousel.Item key={index}>
                            {p.link !== null || p.link2 !== null ? (
                                p.link !== null ? (
                                    <NavLink to={urlDynamic.path.homeFa + p.link}>
                                        <img src={p.url} width="1560" height="450" className='img-fluid rounded rounded-3 w-100'
                                             alt='تصویر'/>
                                    </NavLink>
                                ) : (
                                    p.link2 !== null ? (
                                        <Link to={p.link2} target='_blank'>
                                            <img src={p.url} width="1560" height="450" className='img-fluid rounded rounded-3 w-100'
                                                 alt='تصویر'/>
                                        </Link>
                                    ) : null
                                )
                            ) : (
                                <img src={p.url} width="1560" height="450" className='img-fluid rounded rounded-3 w-100'
                                     alt='تصویر'/>
                            )}
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
            <div className='col-12 d-md-none cMobail'>
                <Carousel fade indicators={false} pause={false} interval={5000}>
                     {context.state.sHome.slider.map((p, index) => (
                        <Carousel.Item key={index}>
                            {p.link !== null || p.link2 !== null ? (
                                p.link !== null ? (
                                    <NavLink to={urlDynamic.path.homeFa + p.link}>
                                        <img src={p.url2} width="768" height="450" className='img-fluid rounded rounded-3 w-100'
                                             alt='تصویر'/>
                                    </NavLink>
                                ) : (
                                    p.link2 !== null ? (
                                        <Link to={p.link2} target='_blank'>
                                            <img src={p.url2} width="768" height="450" className='img-fluid rounded rounded-3 w-100'
                                                 alt={p.alt === null ? null : p.alt}/>
                                        </Link>
                                    ) : null
                                )
                            ) : (
                                <img src={p.url2} width="768" height="450" className='img-fluid rounded rounded-3 w-100'
                                     alt='تصویر'/>
                            )}
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
                 </div>
             </div>
        </div>
    )
}